import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import CarouselEmbed from "../components/CarouselEmbed";

/**
 * Public page at `/gallery/:slug` — renders the named carousel with its
 * own kicker/title/intro shown above the cover-flow. Useful when the user
 * wants to link to a stand-alone photo gallery from anywhere on the site.
 */
export default function GalleryPage() {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/" replace />;

  return (
    <div
      className="min-h-screen bg-[var(--page-bg)] text-[var(--brand-ink)]"
      data-testid="page-gallery"
    >
      <Header />
      <main className="mx-auto max-w-7xl px-5 pt-4 pb-12 sm:px-8 sm:pt-10 sm:pb-16">
        <CarouselEmbed slug={slug} showHeader={true} />
      </main>
      <Footer />
    </div>
  );
}
